import { useCallback, useEffect, useRef, useState } from "react";
import { applyUpdate, registerServiceWorker } from "./register";

export type UsePwaResult = {
  available: boolean;
  apply: () => void;
};

export function usePwa(): UsePwaResult {
  const [reg, setReg] = useState<any>(null);
  const [available, setAvailable] = useState(false);
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    void registerServiceWorker({
      enabled: process.env.REACT_APP_PWA === "1",
      kill: process.env.REACT_APP_PWA_KILL === "1",
      onUpdate: (r: any) => {
        setReg(r);
        setAvailable(true);
      },
    });
  }, []);

  const apply = useCallback(() => {
    applyUpdate(reg);
  }, [reg]);

  return { available, apply };
}

export default usePwa;
